import React from 'react';
import styles from './styles';
import logoCria from '../../assets/image/logoCria.svg';
import logoGoverno from '../../assets/image/logoGoverno.svg';
import logoLaccan from '../../assets/image/logoLaccan.svg';
import logoOrion from '../../assets/image/orionLogo.png'
import logoUfal from '../../assets/image/logoUfal.svg';
import logoFapeal from '../../assets/image/logoFapeal.svg';
import { FooterText } from 'components/FooterText';

const About = () => {
  const logos = [
    { src: logoGoverno, alt: 'Logo do Governo de Alagoas' },
    { src: logoLaccan, alt: 'Logo do LaCCAN' },
    { src: logoOrion, alt: 'Logo do Orion' },
    { src: logoUfal, alt: 'Logo da UFAL' },
    { src: logoFapeal, alt: 'Logo da FAPEAL' },
  ];

  return (
    <div style={styles.aboutContainer}>
      <div style={styles.aboutTextsContainer}>
        <img src={logoCria} alt='Logo do CRIA' style={styles.logo} />
        <h1 style={styles.title}>O que é o CRIA?</h1>

        <p style={styles.textSobre}>
          {' '}
          O Programa CRIA (Criança Alagoana), do Governo do Estado de Alagoas, é
          um benefício financeiro temporário que visa atender de forma integrada
          gestantes e crianças do estado em situação de carência. O programa
          oferece auxílio financeiro, acompanhamento familiar de saúde e
          assistência social.{' '}
        </p>

        <h1 style={styles.titleProg}> Quem pode participar do programa? </h1>

        <div style={styles.list}>
          <ul>
            <li>Gestantes;</li>
            <li>Crianças de 0 (zero) a 6 (seis) anos;</li>
            <li>
              Crianças de 0 (zero) a 6 (seis) anos
              diagnosticadas com síndrome congênita por Zika vírus.
            </li>
          </ul>
        </div>

        <h1 style={styles.title}> Parceiros</h1>
        <div style={styles.logos}>
          {
            logos.map((logo, idx) => (
              <div style={styles.logoGovContainer} key={idx}>
                <img src={logo.src} alt={logo.alt} style={styles.logo} />
              </div>
            ))
          }
        </div>
      </div>

      <div style={styles.footer}>
        <p style={styles.footerText}>
          <FooterText />
        </p>
      </div>
    </div>
  );
};

export default About;
